import React, { useState } from "react";
import styles from "./SmartersTokenModal.module.scss";
import { BaseModal } from "@whatslly/ui-components/modals/BaseModal";
import { IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { TextArea } from "@whatslly/ui-components/v2/BaseElements/TextArea";

export const SmartersTokenModal: React.FC<IModalInstance<string> & { title: string }> = ({ closeModal, title }) => {
  const [token, setToken] = useState("");
  const { t } = useTranslation();
  return (
    <BaseModal
      header={<ModalHeader closeModal={() => closeModal()}>{title}</ModalHeader>}
      closeOnClickOutside={false}
      closeOnEscape={false}
      closeModal={() => closeModal()}
      className={styles.modal}
    >
      <TextArea
        data-testid={"smarters-token-text-area"}
        paddingInline={"none"}
        placeholder={t("whatsapp_business_api_settings_page.smarters_modal.placeholder")}
        onChange={(e) => setToken(e.target.value)}
      />
      <ModalButtons
        isSubmitDisabled={!token}
        testId="modal-buttons-submit-button"
        onCancel={() => closeModal(undefined)}
        onSubmit={() => closeModal(token)}
      />
    </BaseModal>
  );
};
